import { useContext, useEffect, useState } from 'react'
import { UserDetailsContext } from '../../../context/user-details/user-details'
import { OverviewEditForm } from '../../presentation-components/settings-components/overview-edit-form'
import OrganisationService from '../../../shared/services/organisation/organisation.service'
import { IOrganisationDetails } from '../../../shared/services/organisation/organisation.model'
import { Alert, Box, Stack, useMediaQuery } from '@mui/material'
import { UserNotificationsContext } from '../../../context/user-notifications/user-notifications'
import { FileUploadHelper } from '../../presentation-components/miscellaneous-components/file-upload-helper'
import { AvatarDisplay } from '../../presentation-components/display-elements-components/avatar-display'
import GroupService from '../../../shared/services/group/group.service'
import { IGroup } from '../../../shared/services/group/group.model'
import gaiaTheme from '../../../root-components/theme'
import { SettingsMobileNavbar } from '../../../root-components/navigation/settings-mobile-navbar'
import { PageOuterContainer } from '../../../root-components/layouts/page-outer-container'
import { PageHeading } from '../../presentation-components/display-elements-components/page-heading'
import { ScreenLabelsContext } from '../../../context/screen-labels/screen-labels'

export const SettingsOverviewPage = () => {
  const userDetailsContext = useContext(UserDetailsContext)
  const userNotificationsContext = useContext(UserNotificationsContext)
  const screenLabelsContext = useContext(ScreenLabelsContext)
  const organisationService = new OrganisationService();
  const groupService = GroupService.getInstance();
  const organisationDetails = userDetailsContext.userDetails?.organisation
  const [updatedOrganisationDetails, setUpdatedOrganisationDetails] = useState<IOrganisationDetails>();
  const [groups, setGroups] = useState<IGroup[]>([]);
  const [editField, setEditField] = useState<string>('');
  const [fileData, setFileData] = useState([]);
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('sm'));

  useEffect(() => {
    setUpdatedOrganisationDetails(organisationDetails)
  }, []);

  useEffect(() => {
    groupService.getGroups(true)
      .then(response => {
        setGroups(response)
      })
      .catch(err => {
        console.log(err)
      })
  }, [])

  const submitOrganisationHandler = async (postOrganisation: IOrganisationDetails) => {
    organisationService.editOrganisations(postOrganisation)
      .then(response => {
        userDetailsContext.forceUpdateUserDetails();
        userNotificationsContext.openSnackbar({ open: true, message: 'Updated successfully' });
      })
      .catch(err => {
        userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
        console.log(err)
      })
  };

  const uploadCompanyLogo = () => {
    const form = new FormData();
    form.append("files", fileData[0]);
    form.append('organisation', JSON.stringify({ organisationId: userDetailsContext.userDetails?.organisation.id }));
    organisationService.saveLogo(form)
      .then(() => {
        setFileData([]);
        userDetailsContext.forceUpdateUserDetails();
      })
  }

  return (
    <PageOuterContainer>
      {isMobileMode && <Box sx={{ pb: 4 }}>
        <SettingsMobileNavbar />
      </Box>}
      {/* Half-configured org: the rest of the app is disabled until the company
          has a name, so say so here rather than leaving the locks unexplained. */}
      {organisationDetails && organisationDetails.name == null &&
        <Alert severity='info' sx={{ mb: 3 }}>
          Add your company name to unlock the rest of the app.
        </Alert>}
      {organisationDetails &&
        <PageHeading
          title={organisationDetails?.name}
          hasTabs={false}
        />}
      <Stack direction={isMobileMode ? 'column' : 'row'} alignItems={isMobileMode ? 'flex-start' : 'center'} sx={{ pb: 4 }}>
        <Box sx={{ mr: 3, mb: isMobileMode ? 2 : 0 }}>
          <AvatarDisplay color={'primary.light'} width={'75px'} height={'75px'} padding={2} fontSize='2rem' logo={true} />
        </Box>
        <FileUploadHelper
          disableButton={organisationDetails?.name === null ? true : false}
          fileData={fileData}
          setFileData={setFileData}
          buttonCopy={userDetailsContext.userDetails?.organisation?.logoFilepath ? `Update ${screenLabelsContext.getLabel('organisation', { plural: false, capitalize: 'first' })} logo` : `Upload ${screenLabelsContext.getLabel('organisation', { plural: false, capitalize: 'first' })} logo`}
          onSubmit={uploadCompanyLogo}
          hidePreview={true} />
      </Stack>
      {updatedOrganisationDetails && organisationDetails && groups &&
        <OverviewEditForm
          updatedOrganisationDetails={updatedOrganisationDetails}
          organisationDetails={organisationDetails}
          submitOrganisationHandler={submitOrganisationHandler}
          editField={editField}
          setEditField={setEditField}
          groups={groups}
          setGroups={setGroups}
        />
      }
    </PageOuterContainer>
  )
}